import { Injectable, DOCUMENT, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DragNDropHelperService {
  private document = inject<Document>(DOCUMENT);

  updateDragStatus(isDragging: boolean) {
    if (isDragging) {
      this.document.body.classList.add('dragging');
    } else {
      this.document.body.classList.remove('dragging');
    }
  }
}
